module.exports = __webpack_public_path__ + "8abf331419822c547f5d54ffd2b2221b.png";